<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題|内容" @search="searchEvent" :showGj="false">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">提交工單</el-button> -->
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="基础搜索" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="名稱|登錄賬號|APIKEY"></el-input>
						</el-form-item>
					
						
						
					
						
					
				
						
				

					
						
					


						<el-form-item label="創建時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<el-table-column align="center" prop="sp_name" width="150" label="提交商戶">
					<template slot-scope="v">
						<span>{{v.row.shop_name}}(<span class="text-danger">{{v.row.username}}</span>)</span>
						
						
					</template>
				</el-table-column>
					
				
				
				<!-- <el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column> -->
			
				<el-table-column align="center" prop="title" label="反馈標題">
				</el-table-column>
				
				<el-table-column align="center" prop="content" label="反馈内容">
				</el-table-column>
				
				<el-table-column align="center" prop="head"  label="反馈图片">
					<template slot-scope="v">
						<el-image v-if="v.row.head" style="width: 40px; height: 40px" :src="v.row.head" :preview-src-list="[v.row.head]"></el-image>
						<span v-else>-</span>
					</template>
				</el-table-column>
		
				
				
				
				<el-table-column align="center" prop="phone" label="聯絡電話">
				</el-table-column>
			
				
			
				
				
				<el-table-column align="center" prop="email"  label="聯絡郵箱">
			
				</el-table-column>
				
				
			
	
			<!-- <el-table-column align="center" sortable="custom" prop="status"  label="狀態">
				<template slot-scope="scope">
					<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '啟用' : '禁用'}}
					</el-button>
				</template>
			</el-table-column> -->
		
				
				<el-table-column align="center" sortable="custom" prop="status"  label="狀態">
					<template slot-scope="v">
						<span style="color: #999;" v-if="v.row.status==0">等待系统回复</span>
						<span class="text-success" v-if="v.row.status==1">已完成</span>
						<span style="color: #999;" v-if="v.row.status==2">等待系统回复</span>
						<span class="text-warning" v-if="v.row.status==3">系统已回复</span>
						<span class="text-success" v-if="v.row.status==4">商戶關閉工單</span>
					</template>
				</el-table-column>
			
		
			
				
	
			
				
				
	
				
		
				
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="提交時間">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="160" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							
							<el-button  v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">回复</el-button>
							
							<el-button v-auth="'close'+auth_val" v-if="scope.row.status==0 || scope.row.status==2 || scope.row.status==3" @click="closeWord(scope.row)"   size="mini" plain type="warning">關閉工單</el-button>
							
						<!-- 	<el-button @click="deleteItem(scope.row)"  v-auth="'delRule'" size="mini" plain type="danger">刪除</el-button> -->

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'提交工單':form.title" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				<div v-if="editIndex==-1">
					<el-form-item label="反馈標題" prop="title">
						<el-input type="text" v-model="form.title" 
						placeholder="反馈標題" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>			
					
					<el-form-item label="反馈内容" prop="content">
						<el-input type="textarea" :rows="4" v-model="form.content" 
						placeholder="反馈内容" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					<el-form-item label="聯絡電話" prop="phone">
						<el-input type="text"  v-model="form.phone" 
						placeholder="聯絡電話" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					<el-form-item label="聯絡郵箱" prop="email">
						<el-input type="text"  v-model="form.email" 
						placeholder="聯絡郵箱" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item  label="反馈图片" prop="img" >
						<el-upload
						name="file"
						  class="avatar-uploader"
						  action="/admin/image/uploadNew"
						  :headers="{token:$store.state.user.token}"
						  :data="{type:'WorkOrder'}"
						  :show-file-list="false"
						  :on-success="handleAvatarSuccess"
						  :before-upload="beforeAvatarUpload">
						  <img v-if="form.img" :src="form.img" class="avatar">
						  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
				</div>
				

				<div v-if="editIndex!=-1">
					
					<div>
						<div>
							
							<div class="mb-3">
								<el-tag type="info">反馈内容：</el-tag>
								<span class="ml-3">
									{{form.content}}
								</span>
							</div>
							
							<div class="mb-3">
								<el-tag type="info">當前狀態：</el-tag>
								<span class="ml-3">
									<span style="color: #999;" v-if="form.status==0">等待系统回复</span>
									<span class="text-success" v-if="form.status==1">已完成</span>
									<span style="color: #999;" v-if="form.status==2">等待系统回复</span>
									<span class="text-warning" v-if="form.status==3">系统已回复</span>
									<span class="text-success" v-if="form.status==4">商戶關閉工單</span>
								</span>
							</div>
							
							<div class="mb-3">
								<el-tag type="info">提交時間：</el-tag>
								<span class="ml-3">
									{{form.create_time}}
								</span>
							</div>
						</div>
						
						<div style="text-align: right;">
							<el-button v-if="form.status==0 || form.status==2 || form.status==3 " @click="closeWord(form)" v-auth="'close'+auth_val"   size="medium" plain type="warning">關閉工單</el-button>
						</div>
					</div>
					
					
					
					
					
					
					<!-- <el-tag type="info">回复詳情：</el-tag> -->
					<hr>
					<br />	
					<div id="bottomDiv" style="max-height: 300px;overflow-y: auto;">
						<div  v-for="v in form.log" :key="v.id" :class="v.type==1?'wo_li2':''"  class="mb-3 wo_li">
							<el-tag v-if="v.type==2" type="warning" >商戶</el-tag>
							
							<div class="" :class="v.type==1?'mr-3':'ml-3'">
								<div class="wo_time">
									{{v.create_time}}
								</div>
								<div>{{v.content}}</div>
							</div>
							<el-tag v-if="v.type==1" class="mr-3"  type="success">系统</el-tag>
							
						</div>
						
					
						
					</div>
					<br />	
					<hr>
					<div class="wo_btn" v-if="form.status==0 || form.status==2 || form.status==3">
						<el-input class="mr-3" type="textarea" :rows="4" v-model="sendData.content"
						placeholder="新回复内容" 
						clearable size="small" ></el-input>
						<el-button :loading="layout.loading" class="ml-3" size="small" type="primary" plain @click="submitLog">發送</el-button>
					</div>
					

					
					
				</div>
				
				
			
				
				
				
	
		
	
				
			
			
				
		
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer" >
				<el-button @click="createModel = false">{{editIndex==-1?'取 消':'关 闭'}}</el-button>
				<el-button v-if="editIndex==-1" type="primary" @click="submit">確 定</el-button>
				
				
				
			</div>
		</el-dialog>
		
		
		
		
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					title: [{
							required: true,
							message: "反馈標題不能為空",
							trigger: 'blur',
						},
					],
					content: [{
							required: true,
							message: "反馈内容不能為空",
							trigger: 'blur',
						},
					],
					
					
				},
				checkModel:false,
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
				
					time: [],
				},
				model_title: 'Workorder',
				auth_val: 'Workorder',
				preUrl: "apply/workorderList", //列表地址
				addUrl: "apply/addWorkorder", //添加/修改地址
				editStatusUrl: "apply/editStatusWorkorder", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					phone:'',
					email:'',
					title:'',
					content:'',
					img:"",
					head:'',
					create_time:'',
					status:0,
				},
				sendData:{
					id:0,
					content:'',
					
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				checkdata:{
					name:"",
					data:[]
				},
				print_list:[]
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			//this.commonList('printData');
		},
		methods: {
			scrollToBottom(elementId) {
			    this.$nextTick(() => {
			      setTimeout(() => {
			        const element = document.getElementById(elementId);
			        if (element) {
			          element.scrollTop = element.scrollHeight;
			        }
			      }, 100); // 等待 500 毫秒後执行
			    });
			  },
			submitLog(type) {
				if(!this.sendData.content){
					this.$message({
						message: '請輸入發送内容',
						type: 'error'
					});
					return false
				}
				this.layout.loading = true;
				this.axios.post('/admin/apply/addWorkorderlog', this.sendData, {
					token: true,
				}).then(res => {
					let all = res.data
					if(all.code==1){
						this.form.status  = all.data.list.status
						this.form.log  = all.data.list.list
						this.sendData.content = ''
						this.scrollToBottom('bottomDiv')
						this.getList()
						this.layout.getPageNum()
					}
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			 checkLog(id) {

			 	this.layout.loading = true;
			 	this.axios.post('/admin/apply/checkWorkOrderLog', {id:id}, {
			 		token: true,
			 	}).then(res => {
			 		let all = res.data
			 		if(all.code==1){
			 			this.form.is_check  = 1
			 			this.form.log  = all.data.list
						
			 		}
					this.scrollToBottom('bottomDiv')
			 		this.layout.loading = false;
			 	}).catch(err => {
			 		// 失敗
			 		this.layout.loading = false;
			 	})
			 },
			  
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					this.print_list = all.data.list
				
					
			
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						
					
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			
				
			checkShopPnum(e){
				this.checkdata.name = e.name
				
				this.checkdata.data =  []
				this.checkShopPnumApi(e.id)
				this.checkModel = true
			},
			closeWord(e){
					this.$confirm('是否確定要關閉工單?', '提示', {
						confirmButtonText: '確定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.layout.loading = true;
						this.axios.post('/admin/apply/editStatusWorkorder', {
							id: e.id,
						}, {
							token: true,
							loading: true
						}).then(res => {
							
							let all = res.data
							if (all.code == 1) {
								this.$message({
									message: '关單成功',
									type: 'success'
								});
								this.form.status = 1;
								this.getList()
								this.layout.getPageNum()
							}
				
							
				
							this.layout.loading = false;
						}).catch(err => {
							this.layout.loading = false;
						})
					})
				
			},
			
			 
			// 打开模态框
			openModel(e, type) {
				console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						phone:e.phone,
						email:e.email,
						title:e.title,
						content:e.content,
						img: e.head,
						head:e.head,
						create_time:e.create_time,
						status:e.status,
						log:e.log,
						is_check:e.is_check,
						send:'',
					}
					this.checkLog(e.id)
					
					this.sendData.id = e.id
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						phone:'',
						email:'',
						title:'',
						content:'',
						img:"",
						head:'',
						create_time:'',
						status:0,
						log:[],
						is_check:0,
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},
			
			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
				
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
	.wo_li{
		width: 70%;
		display: flex;
		line-height: 25px;
	}
	.wo_li2{
		margin-left: 30%;
	}
	.wo_time{
		font-size: 13px;;
		color: #999;
	}
	.wo_li2{
		justify-content: flex-end;
	}
	.wo_li2 .mr-3{
		text-align: right;
	}
	.wo_btn{
		display: flex;
		align-items: center;
		width: 100%;
	}
</style>
